import {Pipe, PipeTransform} from '@angular/core';
import IFieldCropRotation = Data.FieldManagement.IFieldCropRotation;
import ICropRotation = Data.FieldManagement.ICropRotation;

/**
 * creates a unique Cell Id
 */
@Pipe({
  name: 'idCreator'
})
export class IdCreatorPipe implements PipeTransform {

  transform(value: IFieldCropRotation | ICropRotation, args?: number): string {
    if (!value) {
      return '';
    }
    return value.Id.toString() + '_' + args + '_' + (Array.isArray(value.Yields) && !!value.Yields[args] ? value.Yields[args].MainCrop : 'null');
  }

}
